module.exports = __webpack_public_path__ + "img/human-left.4bf9a594.png";